<template>
  <router-link
    v-if="to"
    class="ai-visibility-panel-action-link"
    :to="to"
    @click.native="$emit('click', $event)"
  >
    <slot />
  </router-link>
  <button
    v-else
    type="button"
    class="ai-visibility-panel-action-link"
    @click="$emit('click', $event)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: 'PanelActionLink',
  props: {
    to: {
      type: [Object, String],
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-panel-action-link {
  display: flex;
  min-height: 32px;
  align-items: center;
  justify-content: center;
  border: 0;
  background: transparent;
  color: var(--v-profileAnchorColor-base);
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  padding: 0;
  text-decoration: none;
  width: 100%;
}

.ai-visibility-panel-action-link:hover {
  text-decoration: underline;
}

.ai-visibility-panel-action-link:focus-visible {
  outline: 2px solid var(--v-lightYellowColor-base);
  outline-offset: 2px;
}
</style>
